<template>
    <div>
        <v-overlay :value="flagLoading" z-index="999">



            <!-- From Uiverse.io by Yaya12085 --> 
             <!-- From Uiverse.io by JkHuger --> 
            <div class="isContainer">
                <div class="cssBlock"></div>
                <div class="cssBlock"></div>
                <div class="cssBlock"></div>
                <div class="cssBlock"></div>
            </div>
            <!-- <span class="loading-text">Loading</span> -->
            <!-- <div style="display: flex; align-items: center; justify-content: center;">
                <div aria-label="Loading..." role="status" class="loader">
            </div> -->
            
            
            <!-- <svg 
                class="icon" 
                width="64px" 
                height="64px" 
                viewBox="0 0 50 50"
            >
                <defs>
                    <linearGradient id="spinner-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                    <stop offset="0%" stop-color="#6A62D2"/>
                    <stop offset="100%" stop-color="#00F7FF"/>
                    </linearGradient>
                </defs>

                <circle
                    cx="25"
                    cy="25"
                    r="22"
                    fill="none"
                    stroke="url(#spinner-gradient)"
                    stroke-width="4"
                    stroke-linecap="round"
                    stroke-dasharray="150"
                    stroke-dashoffset="0"
                >
                    <animateTransform
                    attributeName="transform"
                    attributeType="XML"
                    type="rotate"
                    from="0 25 25"
                    to="360 25 25"
                    dur="1s"
                    repeatCount="indefinite"
                    />
                    
                    <animate
                    attributeName="stroke-dashoffset"
                    values="150;75;0;75;150" 
                    keyTimes="0;0.25;0.5;0.75;1"
                    dur="2s"
                    repeatCount="indefinite"
                    />
                </circle>
            </svg> -->

            <!-- <svg class="icon" viewBox="0 0 256 256">
                <line x1="128" y1="32" x2="128" y2="64" stroke-linecap="round" stroke-linejoin="round" stroke-width="24"></line>
                <line x1="195.9" y1="60.1" x2="173.3" y2="82.7" stroke-linecap="round" stroke-linejoin="round" stroke-width="24"></line>
                <line x1="224" y1="128" x2="192" y2="128" stroke-linecap="round" stroke-linejoin="round" stroke-width="24"></line>
                <line x1="195.9" y1="195.9" x2="173.3" y2="173.3" stroke-linecap="round" stroke-linejoin="round" stroke-width="24"></line>
                <line x1="128" y1="224" x2="128" y2="192" stroke-linecap="round" stroke-linejoin="round" stroke-width="24"></line>
                <line x1="60.1" y1="195.9" x2="82.7" y2="173.3" stroke-linecap="round" stroke-linejoin="round" stroke-width="24"></line>
                <line x1="32" y1="128" x2="64" y2="128" stroke-linecap="round" stroke-linejoin="round" stroke-width="24"></line>
                <line x1="60.1" y1="60.1" x2="82.7" y2="82.7" stroke-linecap="round" stroke-linejoin="round" stroke-width="24"></line>
            </svg> -->
            <!-- </div> -->
        </v-overlay>
    </div>
</template>

<script>
export default {
    props: {
        flagLoading: {
            type: Boolean,
            default: false,
        },
    },
}
</script>

<style scoped>

/* From Uiverse.io by JkHuger */ 
.isContainer {
  display: flex;
  align-items: center;
}

.cssBlock {
  position: relative;
  box-sizing: border-box;
  float: left;
  margin: 0 10px 10px 0;
  width: 12px;
  height: 12px;
  border-radius: 3px;
  background: #f1ad47;
}

.cssBlock:nth-child(4n+1) {
  animation: wave_23 2s ease .0s infinite;
}

.cssBlock:nth-child(4n+2) {
  animation: wave_23 2s ease .2s infinite;
}

.cssBlock:nth-child(4n+3) {
  animation: wave_23 2s ease .4s infinite;
}

.cssBlock:nth-child(4n+4) {
  animation: wave_23 2s ease .6s infinite;
  margin-right: 0;
}

@keyframes wave_23 {
  0% {
    top: 0;
    opacity: 1;
  }

  50% {
    top: 30px;
    opacity: .2;
  }

  100% {
    top: 0;
    opacity: 1;
  }
} 
/* .loader {
  display: flex;
  align-items: center;
}

.icon {
  height: 4rem;
  width: 4rem;
  animation: spin 1s linear infinite;
  stroke: rgba(255, 255, 255,1);
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
} */

.loading-text { 
    position: relative;
    line-height: 1rem;
    font-weight: 500;
    color: rgba(255, 255, 255,1);
    font-size: 2.5rem;
    margin-bottom: 24px;
}

</style>